module.exports = __webpack_public_path__ + "img/mobile-more.31ea65c6.svg";